import React from 'react'
import { useTranslation } from 'react-i18next'
import { NumberInput } from '../../../../../../common/inputs/numberInput/NumberInput'
import { ContentStateProperty } from '../../../../../../../@types/types'
import { parseNumber } from '../../../../../../../services/validation/rules/validationFunctions'
import { formatNumber } from '../../../../../../../i18next/decimal'
import Checkbox from '../../../../../../common/inputs/checkbox/Checkbox'
import styles from './HeatingCosts.module.css'

export interface HeatingCostsProps {
  screenId: string
  heatingCosts?: string
  heatingCostsValidation: string[]
  onChange: (property: ContentStateProperty, value: string | undefined) => void
  onFocusEnter?: () => void
  onFocusLeave?: () => void
  useSimpleLayout?: boolean
  showLabel?: boolean
  heatingCostsUnknown?: boolean
  onHeatingCostsUnknownChange?: (checked: boolean) => void
}

const HeatingCosts: React.FC<HeatingCostsProps> = ({
  heatingCosts,
  heatingCostsValidation,
  onChange,
  onFocusEnter,
  onFocusLeave,
  useSimpleLayout = false,
  showLabel = false,
  heatingCostsUnknown = false,
  onHeatingCostsUnknownChange,
}) => {
  const { t } = useTranslation()

  const label = showLabel ? <span>{t('wizard.screen.costs.heatingCosts')}</span> : undefined
  const placeholder = !showLabel ? t('wizard.screen.costs.heatingCosts') : ''

  const numberInput = (
    <NumberInput
      key={heatingCostsUnknown ? 'unknown' : 'known'}
      id='heating-costs'
      propertyName='heatingCosts'
      placeholder={placeholder}
      label={label}
      value={heatingCostsUnknown || !heatingCosts ? undefined : parseNumber(heatingCosts)}
      minPrecision={0}
      maxPrecision={2}
      affixRight='unit'
      unitRight='eur'
      errors={heatingCostsUnknown ? [] : heatingCostsValidation}
      disabled={heatingCostsUnknown}
      hideMandatorySign={true}
      doOnFieldChange={(property, value) => onChange(property, formatNumber(value))}
      onFocus={onFocusEnter}
      onBlur={onFocusLeave}
    />
  )

  const unknownCostsCheckbox = onHeatingCostsUnknownChange && (
    <div className={styles.unknownHeatingCost}>
      <Checkbox
        id='heating-costs-unknown'
        name='heatingCostsUnknown'
        checked={heatingCostsUnknown}
        label={t('wizard.screen.costs.heatingCostsUnknown')}
        onChange={(_name, checked) => onHeatingCostsUnknownChange(checked)}
      />
    </div>
  )

  if (useSimpleLayout) {
    return (
      <>
        {unknownCostsCheckbox}
        <div>{numberInput}</div>
      </>
    )
  }

  return (
    <>
      <div className='inline-block margin-top-m one-whole'>
        <div className='inline-block two-twelfth align-top padding-top-m'>
          <span className='lap-margin-left-m desk-margin-left-m margin-left-xxl path-symbol-before' />
        </div>
        <div className='inline-block ten-twelfth'>
          {unknownCostsCheckbox}
          {numberInput}
        </div>
      </div>
    </>
  )
}

export default HeatingCosts
